export type OperationsWeeklyGrossTargets = Record<
  string,
  Record<string, { gross: number; rpm: number }>
>;

export const operationsWeeklyGrossTargets: OperationsWeeklyGrossTargets = {
  "2026-03": {
    rgn: { gross: 9500, rpm: 4 },
    step: { gross: 8500, rpm: 3 },
    flat: { gross: 8000, rpm: 2.75 },
    reefer: { gross: 8500, rpm: 3 },
    dryvan: { gross: 7000, rpm: 2.6 },
    conestoga: { gross: 8000, rpm: 2.75 },
    po: { gross: 6500, rpm: 2 },
  },
};
